import { type MaybeRefOrGetter, computed, toValue } from 'vue'

const THOUSAND_SEPARATOR_REGEX = /\B(?=(\d{3})+(?!\d))/g

export const useNumberFormatted = (
  numberRaw: MaybeRefOrGetter<number>,
  separatorRaw: MaybeRefOrGetter<string> = '\xA0'
) => {
  const numberFormatted = computed(() =>
    toValue(numberRaw)
      .toString()
      .replace(THOUSAND_SEPARATOR_REGEX, toValue(separatorRaw))
  )

  return numberFormatted
}
